import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { AutorisationBnbaccess } from './autorisation-bnbaccess.model';
import { AutorisationBnbaccessPopupService } from './autorisation-bnbaccess-popup.service';
import { AutorisationBnbaccessService } from './autorisation-bnbaccess.service';

@Component({
    selector: 'jhi-autorisation-bnbaccess-delete-dialog',
    templateUrl: './autorisation-bnbaccess-delete-dialog.component.html'
})
export class AutorisationBnbaccessDeleteDialogComponent {

    autorisation: AutorisationBnbaccess;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private autorisationService: AutorisationBnbaccessService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['autorisation']);
    }

    clear () {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete (id: number) {
        this.autorisationService.delete(id).subscribe(response => {
            this.eventManager.broadcast({
                name: 'autorisationListModification',
                content: 'Deleted an autorisation'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-autorisation-bnbaccess-delete-popup',
    template: ''
})
export class AutorisationBnbaccessDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor (
        private route: ActivatedRoute,
        private autorisationPopupService: AutorisationBnbaccessPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.autorisationPopupService
                .open(AutorisationBnbaccessDeleteDialogComponent, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/autorisation/autorisation-bnbaccess-delete-dialog.component.ts